import { internalLogger } from '../../interface/v1/clientOsLogger';
import { RepositoriesType } from './RepositoriesType';
import { getRepositories } from '../startup';

let repositories: RepositoriesType;

export const clearRepositories = (skipList = []): void => {
  try {
    repositories = getRepositories();
  } catch (error) {
    internalLogger?.error?.(error);
  }

  // Filter repositories based on the skipList.
  const repoNames = Object.keys(repositories);

  const allowedList = repoNames.filter((repo) => !skipList.includes(repo));

  const repositoriesToClear = allowedList.map((r) => repositories[r]);
  /* istanbul ignore next */
  internalLogger?.debug?.d4({
    className: 'ClearRepositories',
    methodName: 'clearRepositories',
    message: 'Clear the following repositories from JSHELL.',
    variables: { repositoriesToClear }
  });

  repositoriesToClear?.forEach((r) => r?.clear?.());
};
